import { FC } from "react";
import { useSelector } from "react-redux";
import {
    isCurrentWorkOwner,
    selectIsWorkSavePending,
} from "../../../slices/works-slice";
import { WorkDTO } from "../../../domain/models/dto/WorkDTO";
import HeartIconSVG from "../svg/HeartIconSVG";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { WorkServiceImpl } from "../../../services/WorkServiceImpl";

interface AddToSavedButtonProps {
    work: WorkDTO;
    className?: string;
    labelEnabled?: boolean;
}

const AddToSavedButton: FC<AddToSavedButtonProps> = (props) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const isOwner = useSelector(isCurrentWorkOwner(props.work));
    const isSaving = useSelector(selectIsWorkSavePending(props.work.id));
    const savedHandler = async () => {
        if (isSaving) return;

        try {
            await dispatch(
                WorkServiceImpl.saveWorkByIdThunk({ id: props.work.id })
            ).unwrap();
        } catch {
            // The rejected action leaves the existing saved state unchanged.
        }
    };

    return (
        <>
            {!isOwner && (
                <div
                    onClick={savedHandler}
                    aria-disabled={isSaving}
                    className={`flex items-center justify-center group ${
                        isSaving ? "cursor-wait" : "cursor-pointer"
                    } ${props.className}`}
                >
                    {props.labelEnabled && (
                        <span className="H20 dmax2:H16 text-textFaded mr-3 group-hover:text-textWhite transition duration-200">
                            {t(props.work.workUser?.saved ? "work.removeFromSaved" : "work.addToSaved")}
                        </span>
                    )}
                    <HeartIconSVG
                        fill={props.work.workUser?.saved ? "#0F6ABE" : "none"}
                        className={`${
                            props.work.workUser?.saved
                                ? "text-primaryBlue"
                                : "group-hover:text-textWhite text-textFaded"
                        } w-8 h-8 transition duration-200`}
                    />
                </div>
            )}
        </>
    );
};

export default AddToSavedButton;
